import { isJsonLike, parseJson } from '@/utils/infrastructure';

export const renderJsonSelectValue = (value, field) => {
  if (!value) return '';

  // If the value is an object with displayText, use it directly
  if (typeof value === 'object' && value?.displayText) {
    return value.displayText;
  }

  if (typeof value === 'string' && isJsonLike(value)) {
    const parsed = parseJson(value);
    if (parsed?.displayText) {
      return parsed.displayText;
    }
    if (parsed?.items && parsed.items.length > 0) {
      const item = parsed.items[0];
      return item.text || item.label || item.searchValue || '';
    }
  }

  return value;
};
